import {apiFetch} from '../../security/apiFetch';
import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Box, Button, CircularProgress, List, ListItem, ListItemText, Typography } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
interface AdminSession { id: string; created_at: string; expires_at: string; revoked_at: string | null; current: boolean; }
const Tokens: React.FC = () => {
  const { token, user, refreshAuth } = useAuth();
  const [sessions, setSessions] = useState<AdminSession[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const load = useCallback(async () => {
    if (!token) return;
    setLoading(true); setError('');
    try {
      const r = await apiFetch('/api/v1/auth/admin/sessions', { headers: { Authorization: `Bearer ${token}` }, cache: 'no-store' });
      if (r.status === 401) { await refreshAuth(); return; }
      if (!r.ok) throw new Error('Не удалось получить сессии.');
      setSessions(await r.json());
    } catch (e) { setError(e instanceof Error ? e.message : 'Ошибка соединения.'); }
    finally { setLoading(false); }
  }, [token, refreshAuth]);
  useEffect(() => { void load(); }, [load]);
  const revoke = async (id?: string) => {
    if (!token || !user || busy) return;
    setBusy(true); setError('');
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const r = id
        ? await apiFetch(`/api/v1/auth/admin/sessions/${id}`, { method: 'DELETE', headers })
        : await apiFetch(`/api/v1/auth/admin/users/${user.id}/revoke-sessions`, { method: 'POST', headers });
      if (!r.ok && r.status !== 401) throw new Error('Сервер не подтвердил отзыв.');
      await refreshAuth(); await load();
    } catch (e) { setError(e instanceof Error ? e.message : 'Ошибка соединения.'); }
    finally { setBusy(false); }
  };
  return <Box><Typography variant="h4" gutterBottom>Admin-сессии</Typography>
    <Alert severity="info">Срок сессии — 15 минут. Продление требует нового входа. Здесь показаны реальные серверные сессии, без выдачи постоянных токенов.</Alert>
    {error && <Alert severity="error">{error}</Alert>}
    <Button onClick={() => void load()} disabled={loading || busy}>Обновить</Button>
    <Button onClick={() => void revoke()} disabled={busy}>Отозвать все мои сессии</Button>
    {loading ? <CircularProgress /> : <List>{sessions.map(s => <ListItem key={s.id} secondaryAction={<Button disabled={busy || !!s.revoked_at} onClick={() => void revoke(s.id)}>Отозвать</Button>}>
      <ListItemText primary={s.current ? 'Текущая сессия' : 'Admin-сессия'} secondary={`До ${new Date(s.expires_at).toLocaleString()}${s.revoked_at ? ' · Отозвана' : ''}`} />
    </ListItem>)}</List>}
  </Box>;
};
export default Tokens;
